import { render, staticRenderFns } from "./Healthcare.vue?vue&type=template&id=eefc3616&scoped=true&"
import script from "./Healthcare.vue?vue&type=script&lang=js&"
export * from "./Healthcare.vue?vue&type=script&lang=js&"
import style0 from "./Healthcare.vue?vue&type=style&index=0&id=eefc3616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefc3616",
  null
  
)

export default component.exports